import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'allinurl' },
  { name: 'inurl' },
  { name: 'allintitle' },
  { name: 'intitle' },
  { name: 'allintext' },
  { name: 'intext' },
  { name: 'allinanchor' },
  { name: 'inanchor' },
  { name: 'filetype' },
  { name: 'site' },
  { name: 'related' },
  { name: 'info' },
  { name: 'cache' },
  { name: 'define' },
  { name: 'link' }
]

const MAX_QUERY_LENGTH = 256

const bracketSpaceBracketReplaceRE = new RegExp('\\) \\(', 'g')

const defaultSyntaxGuideUrl = 'https://scholar.google.com/intl/en/scholar/help.html#searching'

class GoogleScholarEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Google Scholar')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  mapOperator (operator) {
    switch (operator.toUpperCase()) {
      case 'AND': return { op: '', spaces: true }
      case 'OR': return { op: '|', spaces: false }
      case 'NOT': return { op: '-', spaces: true }
    }
    return { op: operator, spaces: true }
  }
  formulateQuery (query) {
    return 'https://scholar.google.com/scholar?q=' + query
  }
  formulateQueryFromTreeDataInternal (treeData) {
    let r = super.formulateQueryFromTreeDataInternal(treeData)
    r = r.replace(bracketSpaceBracketReplaceRE, ')(')
    return r
  }
  countLevels (queryGraphData, level = 1, maxLevel = 1) {
    let newMaxLevel = maxLevel > level ? maxLevel : level
    if (typeof queryGraphData.children !== 'undefined') {
      const thisChildrenCount = queryGraphData.children.length
      for (const i of queryGraphData.children) {
        if (i.children && i.children.length > 0) {
          const addBrackets = i.isNegative || thisChildrenCount > 1
          const x = this.countLevels(i, addBrackets ? level + 1 : level, maxLevel < level ? level : maxLevel)
          if (x > newMaxLevel) {
            newMaxLevel = x
          }
        }
      }
    }
    return newMaxLevel
  }
  lintQuery (queryGraphData) {
    // Check for any field specifiers used that are not in the supported list
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    const r = m ? [m] : []
    // Check for query being too long
    const q = this.formulateQueryFromTreeData(queryGraphData)
    if (q && q.length > MAX_QUERY_LENGTH) {
      r.push(this.formatErrorMessage('charLimit', MAX_QUERY_LENGTH))
    }
    // Checking for nested cases on first level groups (n.b. top level is canvas)
    if (this.countLevels(queryGraphData) > 2) {
      r.push(this.formatErrorMessage('oneLevelSubexpressionNesting'))
    }
    // Check for any terms with a trailing asterisk
    let trailingAsteriskExists = false
    this.scanGraphQueryData(queryGraphData, partData => {
      if (typeof partData.isGroup === 'undefined' || !partData.isGroup) {
        if (partData.text && partData.text.charAt(partData.text.length - 1) === '*') {
          trailingAsteriskExists = true
        }
      }
    })
    if (trailingAsteriskExists) {
      r.push(this.formatErrorMessage('trailingAsterisksTruncation'))
    }
    return r
  }
}

export default GoogleScholarEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/GoogleScholarEngine.js